import { CogsCards } from '@/feature/financial-model/ecommerce/cogs/components/CogsCards'

const CogsHistoricalRoute = () => <CogsCards tab='historical' />

export default CogsHistoricalRoute
